export const APP_PATHS = {
  root: "/",
  onboarding: "/onboarding",
  map: "/map",
  play: "/play",
  parent: "/parent",
} as const;

export type AppHomePath =
  | typeof APP_PATHS.onboarding
  | typeof APP_PATHS.map;
